import { render } from "./foerdermittelBeratung.vue?vue&type=template&id=6db9a123"
import script from "./foerdermittelBeratung.vue?vue&type=script&lang=js"
export * from "./foerdermittelBeratung.vue?vue&type=script&lang=js"

import "./foerdermittelBeratung.vue?vue&type=style&index=0&id=6db9a123&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__